  document.addEventListener('DOMContentLoaded', () => {
      function initQuizScript() {
          const shadowHost = document.querySelector('#shadow-quiz');
          if (!shadowHost || !shadowHost.shadowRoot) {
              // Retry quickly if shadow DOM isn't ready yet
              setTimeout(initQuizScript, 100);
              return;
          }
          
          const shadowRoot = shadowHost.shadowRoot;
          
          function showElementsAfterMove() {
              const itemIds = ['rsbi-a9e4c7ce', 'rsbi-fe5c3999', 'rsbi-7c996b8c'];
              
              itemIds.forEach(itemId => {
                  const element = shadowRoot.querySelector(`#${itemId}`);
                  if (element) {
                      element.style.opacity = '1';
                      element.style.display = 'flex';
                      element.style.transition = 'all 0.3s ease';
                      console.log(`Shown ${itemId} after move`);
                  }
              });
          }
          
          const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                  if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                      mutation.addedNodes.forEach((node) => {
                          if (node.nodeType === Node.ELEMENT_NODE) {
                              // Check for results section
                              if (node.id === 'rs-62ff96d3') {
                                  applyResultsStyling(node);
                              } else {
                                  const resultsElement = node.querySelector('#rs-62ff96d3');
                                  if (resultsElement) {
                                      applyResultsStyling(resultsElement);
                                  }
                              }
                          }
                      });
                  }
                  
                  const resultsElement = shadowRoot.querySelector('#rs-62ff96d3');
                  if (resultsElement && !resultsElement.dataset.styled) {
                      applyResultsStyling(resultsElement);
                  }
              });
          });
          
          function extractURLsFromSpans() {
              const linksContainer = shadowRoot.querySelector('#rsbc-c9e096c3');
              if (!linksContainer) return [];
              
              const urls = [];
              const spans = linksContainer.querySelectorAll('span');
              
              spans.forEach((span) => {
                  const urlText = span.textContent.trim();
                  if (urlText) {
                      urls.push(urlText);
                  }
              });
              
              console.log('Extracted URLs:', urls);
              return urls;
          }
          
          function moveElementsToSameParentAndApplyFlex() {
              const itemIds = ['rsbi-a9e4c7ce', 'rsbi-fe5c3999', 'rsbi-7c996b8c'];
              
              const firstElement = shadowRoot.querySelector(`#${itemIds[0]}`);
              if (!firstElement) {
                  console.log('First element not found');
                  return null;
              }
              
              let targetParent = firstElement.parentElement;
              while (targetParent && (!targetParent.classList.contains('block') || !targetParent.classList.contains('results-block'))) {
                  targetParent = targetParent.parentElement;
              }
              
              if (!targetParent) {
                  console.log('Parent with "block results-block" classes not found');
                  return null;
              }
              
              console.log('Found target parent:', targetParent);
              
              targetParent.style.display = 'flex';
              targetParent.style.flexDirection = 'row';
              targetParent.style.gap = '2.5rem';
              targetParent.style.maxWidth = '55.68rem';
              targetParent.style.margin = '0 auto';

              itemIds.slice(1).forEach(itemId => {
                  const element = shadowRoot.querySelector(`#${itemId}`);
                  if (element && element.parentElement !== targetParent) {
                      console.log(`Moving ${itemId} to target parent`);
                      targetParent.appendChild(element);
                  }
              });

              if (innerWidth <= 768){
                    targetParent.style.flexDirection = 'column';
                    targetParent.style.gap = '0';
                    targetParent.style.paddingInline = '1rem';
                    
                    // Apply 100% width to all img elements inside result-image-block
                    const imgElements = targetParent.querySelectorAll('.result-image-block img');
                    imgElements.forEach(img => {
                        img.style.width = '100%';
                    });
                }
              
              return targetParent;
          }
          
          function wrapImagesWithLinks(urls) {
              const itemIds = ['rsbi-a9e4c7ce', 'rsbi-fe5c3999', 'rsbi-7c996b8c'];
              
              itemIds.forEach((itemId, index) => {
                  const itemElement = shadowRoot.querySelector(`#${itemId}`);
                  if (itemElement && urls[index]) {
                      
                      const img = itemElement.querySelector('img');
                      if (img && !img.parentElement.matches('a')) {
                          const anchor = document.createElement('a');
                          anchor.href = urls[index];
                          anchor.target = '_blank';
                          
                          const imgClone = img.cloneNode(true);
                          img.parentNode.replaceChild(anchor, img);
                          anchor.appendChild(imgClone);
                          
                          console.log(`Wrapped image in ${itemId} with link: ${urls[index]}`);
                      }
                  }
              });
          }
          
          function applyResultsStyling(resultsElement) {
              if (resultsElement.dataset.styled) return;
              
              console.log('Results section detected! Applying styling...');
              resultsElement.dataset.styled = "true";
              
              // Use requestAnimationFrame for smoother execution
              requestAnimationFrame(() => {
                  const urls = extractURLsFromSpans();
                  if (urls.length > 0) {
                      wrapImagesWithLinks(urls);
                  }
                  
                  moveElementsToSameParentAndApplyFlex();
                  
                  // Show elements immediately after operations
                  requestAnimationFrame(() => {
                      showElementsAfterMove();
                  });

                applyResultsPopups();

              });
              
              console.log('Styling applied to individual elements');
          }

            function applyResultsPopups(){
                console.log('Setting up popup events...');
                
                const checkResultsDetailsPopup = shadowRoot.querySelector('#rsbb-d31bc0a6 button');
                const compareAllBrandsPopup = shadowRoot.querySelector('#rsbb-462417b5 button');

                // First button
                if (checkResultsDetailsPopup) {
                    checkResultsDetailsPopup.removeAttribute('disabled');
                    checkResultsDetailsPopup.addEventListener('click', (e) => {
                        e.preventDefault();
                        const popup = document.querySelector('#productComparisonOverlay'); // Replace with your popup ID
                        if (popup) popup.style.display = 'block';
                    });
                }

                // Second button
                if (compareAllBrandsPopup) {
                    compareAllBrandsPopup.removeAttribute('disabled');
                    compareAllBrandsPopup.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (typeof openBrandsComparison === 'function') {
                            openBrandsComparison();
                        }
                    });
                }
            }


          observer.observe(shadowRoot, {
              childList: true,
              subtree: true
          });
          
          // Check immediately if results already exist
          const existingResults = shadowRoot.querySelector('#rs-62ff96d3');
          if (existingResults) {
              applyResultsStyling(existingResults);
          }
          
          console.log('Quiz script initialized successfully');
      }
      
      // Start immediately, no delay
      initQuizScript();
  });